// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__RMRYD","with":"icon_with__ezV4z"};